import { render, staticRenderFns } from "./ActivityModalForm.vue?vue&type=template&id=12a71196&scoped=true"
import script from "./ActivityModalForm.vue?vue&type=script&lang=ts"
export * from "./ActivityModalForm.vue?vue&type=script&lang=ts"
import style0 from "./ActivityModalForm.vue?vue&type=style&index=0&id=12a71196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a71196",
  null
  
)

export default component.exports